<template>
  <div class="fixed-bottom-area fixed-button">
    <button type="button" class="btn btn-back" @click="clickBack()" v-if="!noBackButtonRoutes.includes(route.path)">이전</button>
    <div class="quick-nav-area" v-if="!noQuickButtonsRoutes.some(routeStr => route.path.startsWith(routeStr))">
      <div class="quick-nav" v-if="showQuickNav">
        <h3 class="sr-only">퀵 메뉴</h3>
        <ul class="list">
          <li @click="clickQuickNav('/', 1, '홈')" class="item-link home">홈</li>
          <li @click="clickQuickNav('/goods/catalog?code=00010010', 2, '드시모네')" class="item-link">드시모네</li>
          <li @click="clickQuickNav('/goods/catalog?code=00010022', 3, '오투부스터')" class="item-link">오투부스터</li>
          <li @click="clickQuickNav('/goods/catalog?code=000100200001', 4, '김석진랩')" class="item-link">김석진랩</li>
          <li @click="clickQuickNav('/goods/catalog?code=000100200002', 5, '또박케어랩')" class="item-link">또박케어랩</li>
          <li @click="clickQuickNav('/faq', 6, '고객센터')" class="item-link">고객센터</li>
          <!-- <li><button type="button" class="item-link close" @click="showQuickNav = false">퀵 메뉴 닫기</button></li> -->
        </ul>
      </div>
      <button type="button" class="btn btn-nav-toggle" @click="showQuickNav = !showQuickNav">퀵 메뉴 열기/닫기</button>
    </div>
    <button type="button" class="btn btn-scroll-top" @click="clickTop()">위로 이동</button>
    <button type="button" class="app" v-if="false" @click="goTobakApp()">
      <div class="main-hilda">
        <Vue3Lottie :animationData="hildaBasicRef" class="main-hilda-lottie" />
      </div>
    </button>
  </div>
</template>



<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { isMobileApp, ttobakAppVersionCheck, goBackTobakApp, isAndroid, isIOS, closeWebview } from '@/utils/common';
import hildaBasic from '@/assets/images/hilda/hilda_basics.json';

const hasHomeBar = ref(false);
const showQuickNav = ref(false);
const hildaBasicRef = ref(hildaBasic);
const router = useRouter();
const route = useRoute();

// 백버튼이 안 보이는 경로 설정
const noBackButtonRoutes = ['/'];

// 퀵메뉴버튼이 안 보이는 경로 설정
const noQuickButtonsRoutes = ['/goods/view', '/order/cart', '/order/'];


const clickBack = () => {
  const currentPath = router.currentRoute.value.path;
  const currentPath2222 = window.location.pathname;
  const backPath = window.history.state?.back;

  //앱인경우
  if (isMobileApp() && ttobakAppVersionCheck() === 'vsl4') {
    if (!backPath) {
      console.log('backPath가 없습니다::메인으로 이동');
      closeWebview();
    } else {
      router.back();
    }
  } else {
    if (!backPath) {
      //backPath가 없으면 메인으로 이동
      router.replace('/');
    } else {
      //기존 ios, 이벤트 처리
      if (isIOS() && backPath.includes('/event/')) {
        if (backPath.includes('null') || backPath.includes(route.path)) {
          router.replace('/');
        } else {
          router.replace(backPath);
        }
      } else {
        router.back();
      }
    }
  }
};

watch(
  () => route.fullPath, 
  async (newPath, oldPath) => {
    if (newPath !== oldPath) {
      showQuickNav.value = false;
    }
  },
  { immediate: true } // 페이지 로드 시에도 즉시 실행
);

//퀵메뉴 클릭시
const clickQuickNav = ( url : any, index:number, name: string) => {
  const eventProperties = {
    index : index,
    quickmenu_name1 : name
  };
  amplitudeSendEvent('click_quick_banner01', eventProperties);
  navigateTo(url);
  showQuickNav.value = false;
}

const clickTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// 모바일 홈바 체크
const requestHasHomeBar = () => {
  if (isAndroid()) {
    window.android.requestHasHomeBar();
  } else if (isIOS()) {
    const message = {
      action: 'requestHasHomeBar',
    };
    window.webkit?.messageHandlers?.experCounselHandler?.postMessage(message);
  } else {
    window.responseHasHomeBar?.('false');
  }
};

const goTobakApp = () => {
  goBackTobakApp();
};

onMounted(() => {
  if (isMobileApp() && ttobakAppVersionCheck() === 'vsl4') {
    requestHasHomeBar();

    // 홈바 여부 체크
    const responseHasHomeBar = (hasBar: string) => {
      console.log('responseHasHomeBar:::::::::', hasBar);
      hasHomeBar.value = hasBar === 'true';
      console.log('test hasBar 응답:::::', hasHomeBar.value);
    };

    (window as any).vue = {
      requestHasHomeBar,
      responseHasHomeBar,
    };
  }
});
</script>

<style lang="scss" scoped>
  $fixed-btn-position-x: 2.4rem;
  $fixed-btn-position-y: 4rem;
  $fixed-btn-size: 9.8rem;
  $fixed-btn-gap: 1.2rem;
  .fixed-bottom-area, .quick-nav-area {
    pointer-events: none;
  }
  .fixed-bottom-area {
    position: fixed;
    left: $fixed-btn-position-x;
    right: $fixed-btn-position-x;
    bottom: $fixed-btn-position-y;
    z-index: 10;
    .btn, .quick-nav {
      background-color: rgba($white, .9);
      border: $border-trans;
      border-radius: $border-radius-lg;
      pointer-events: auto;
    }
    .btn {
      padding: 0;
      width: $fixed-btn-size;
      height: $fixed-btn-size;
      background-size: 7.2rem;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: $border-radius-circle;
      font-size: 0;
      &:active {
        background-color: rgba($white, .9);
        border: $border-trans;
      }
      &.btn-back {
        background-image: url('@/assets/images/icon/arrow-left.svg');
      }
      &.btn-nav-toggle {
        background-image: url('@/assets/images/icon/bolt-primary.svg');
      }
      &.btn-scroll-top {
        position: absolute;
        right: 0;
        bottom: 0;
        background-image: url('@/assets/images/icon/arrow-up.svg');
      }
    }
    .quick-nav-area {
      position: absolute;
      right: 0;
      bottom: $fixed-btn-size + $fixed-btn-gap;
      display: flex;
      flex-direction: column;
      align-items: end;
      width: 16.8rem;
      .quick-nav {
        margin-bottom: $fixed-btn-gap;
        width: 16.8rem;
        font-size: $main-font-size-base;
        border-radius: $border-radius-lg;
        .item-link {
          display: block;
          width: 100%;
          background: none;
          border: 0;
          line-height: 6rem;
          text-align: center;
          &.home, &.close {
            font-size: 0;
          }
          &.home {
            height: 8.6rem;
            background: url('@/assets/images/icon/home-primary.svg') center bottom / 7.2rem no-repeat;
          }
          &.close {
            background: url('@/assets/images/icon/angle-down.svg') center / 1.8rem 3.6rem no-repeat;
            line-height: 5.4rem;
          }
          &:last-child {
            padding-bottom: 2rem;
          }
        }
      }
    }
    // 상품 상세 페이지 위치 조정
    .goods-fixed-button & {
      bottom: 18.8rem;
    }
    // 장바구니 페이지 위치 조정
    .cart-fixed-button & {
      bottom: 25.8rem;
    }
  }
</style>